import { GetServerSidePropsContext } from 'next'

import { ENABLE_I18N } from '@src/config/env'
import { TCountry } from '@src/config/i18n.config'
import { I18N_PREVIEW_KEY, I18N_PREVIEW_TTL_MINUTES } from '@src/constants/i18n.constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

import { setCookie, getCookieHeaderValue } from '../set-response-headers'

import { isRequestSecure } from './request.utils'

export const isCountryCanada = (country: TCountry) => country.toLowerCase() === 'ca'
export const isCountryUS = (country: TCountry) => country.toLowerCase() === 'us'

export const getBFFApiVersion = (isI18nPreviewEnabled: boolean, apiVersion?: string) => {
  if (apiVersion === 'v3') {
    return 'v3'
  }
  if (isI18nPreviewEnabled) {
    return 'v2'
  } else {
    return 'v1'
  }
}

export function shouldEnableI18nServer(ctx: GetServerSidePropsContext): boolean {
  if (!ENABLE_I18N) return false

  const queryParamValue = ctx.query[I18N_PREVIEW_KEY]
  const enableI18nPreview = queryParamValue === 'true'
  const disableI18nPreview = queryParamValue === 'false'

  if (enableI18nPreview) {
    const cookieValue = getCookieHeaderValue(I18N_PREVIEW_KEY, 'true', {
      expiryMinutes: I18N_PREVIEW_TTL_MINUTES,
      isSecure: isRequestSecure(ctx),
    })
    setCookie(ctx, cookieValue)
    return true
  } else if (disableI18nPreview) {
    const cookieValue = getCookieHeaderValue(I18N_PREVIEW_KEY, 'false', {
      expiryMinutes: -1,
      isSecure: isRequestSecure(ctx),
    })
    setCookie(ctx, cookieValue)
    return false
  }

  const hasCookie = ctx.req.cookies[I18N_PREVIEW_KEY] === 'true'
  return hasCookie
}

export function shouldEnableI18nClient(): boolean {
  if (!isBrowser() || !ENABLE_I18N) return false

  const hasQueryParam = new URLSearchParams(window.location.search).get(I18N_PREVIEW_KEY) === 'true'
  const hasCookie = getCookie(I18N_PREVIEW_KEY) === 'true'

  return hasQueryParam || hasCookie
}
